<template>
  <div class="data">
    <h2 class="client">我们的客户</h2>
    <div class="desc-box">
      <p class="desc">
        一匠科技始终坚持贯彻“匠心研发，倾力服务“经营理念，6年时间优秀作品研发超过800个，合作供应商规模达40家合作企业超过600家，其中包括中国中铁、中国石化、中国邮政、中国移动、丰顺旅游局等国内知名企业与社会机构
      </p>
    </div>
    <p></p>
    <ul class="data-list clearfix">
      <li>
        <p class="title">经验</p>
        <h4>{{ one }}+</h4>
        <p><img src="../../static/images/hd1.png" />6年专注，技术雄厚</p>
      </li>
      <li>
        <p class="title">团队</p>
        <h4>{{ two }}+</h4>
        <p><img src="../../static/images/hd4.png" />超过50人的技术开发团队</p>
      </li>
      <li>
        <p class="title">企业/单位</p>
        <h4>{{ three }}+</h4>
        <p><img src="../../static/images/hd2.png" />服务超过600家企业</p>
      </li>
      <li>
        <p class="title">产品</p>
        <h4>{{ four }}+</h4>
        <p><img src="../../static/images/hd3.png" />多年技术沉淀，优秀产品</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Data",
  data() {
    return {
      one: 0,
      two: 0,
      three: 0,
      four: 0,
    };
  },
  mounted() {
    document.addEventListener("scroll", this.ChangeData, false);
  },
  methods: {
    ChangeData() {
      let num = document.body.scrollTop || document.documentElement.scrollTop;
      // console.log(num)
      if (num >= 350) {
        let one_timer = setInterval(() => {
          this.one++;
          if (this.one == 6) {
            clearInterval(one_timer);
          }
        }, 2000 / 5);
        let two_timer = setInterval(() => {
          this.two++;
          if (this.two == 50) {
            clearInterval(two_timer);
          }
        }, 2000 / 40);
        let three_timer = setInterval(() => {
          this.three += 2;
          if (this.three == 600) {
            clearInterval(three_timer);
          }
        }, 3000 / 500);
        let four_timer = setInterval(() => {
          this.four += 2;
          if (this.four == 800) {
            clearInterval(four_timer);
          }
        }, 3000 / 500);
        document.removeEventListener("scroll", this.ChangeData, false);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';


.data {
  background: url('../../static/images/kehu.png') no-repeat ;
  background-size:cover;
  background-position:center;
  vertical-align: middle;
  width: 100%;
  margin: 0 auto;
  height: 457px;
  padding: 80px 0;
  box-sizing: border-box;

  .client {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #FFFFFF;
  }

  .desc-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    
line-height: 30px;

    .desc {
      width: 980px;
      font-size: 18px;
      font-weight: 400;
      color: #FFFFFF;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
    }
  }

  .data-list {
    display: flex;
    justify-content: center;
    padding: 20px 0  0 ;
    margin: 0 auto;
    box-sizing:border-box;

    .title {
      font-weight: 400;
      color: #FFC000;
      padding: 0 0 23px 43px;
    }

    li {
      float: left;
      padding-right: 126px;

      h4 {
        color: $yellow;
        font-size: 48px;
        line-height: 28px;
        letter-spacing: 1px;
        padding-left: 43px;
        font-family: 'Rajdhani-Regular';
      }

      p {
        color: #ffffff;
        font-weight: 600;
        font-size: 16px;
        line-height: 28px;
        margin-top: 21px;

        img {
          width: 28px;
          height: 28px;
          margin-right: 14px;
          vertical-align: text-bottom;
        }
      }
    }

    li:last-of-type {
      padding-right: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/HomeData.vue